import React from "react";
import { useHistory, useParams } from "react-router-dom";
import useAxios from "axios-hooks";
import { CheckList } from "./Container.js";
import { Spinner, Text, Stack } from "@fluentui/react";
import { StylesProvider } from "@material-ui/core/styles";
import "../CheckList/css/FontAwesome/font-awesome.css";
import "../CheckList/css/fonts.css";
import "../CheckList/css/hover.css";
import "../CheckList/css/custom.css";
import env from "../../../../../env";

const { REACT_APP_WWW_BASE_URL } = env;

function prependEnvSlug(slug) {
  const base = REACT_APP_WWW_BASE_URL?.endsWith("/") && slug?.startsWith("/")
    ? REACT_APP_WWW_BASE_URL.slice(0, -1)
    : REACT_APP_WWW_BASE_URL;
  return base + slug;
}
const ChecklistPreviewPage = ({ checklistId }) => {
  const history = useHistory();

  const goToSignUp = () => history.push(REACT_APP_WWW_BASE_URL + "/signup");

  let { checklistId: checklistIdFromParams } = useParams();
  const [{ data: checklist, loading }] = useAxios({
    url: `checklist/${checklistIdFromParams || checklistId}/preview`,
    method: "get",
  });

  if (loading) {
    return <Spinner className="absolute-center" label="Loading Checklist..." />;
  }
  if (!checklist) {
    return <Text>No checklist to display</Text>;
  }
  const actionItemsWithCurrentENVSlugs = checklist.actionItems.map((actionItem) => ({
    ...actionItem,
    slug: prependEnvSlug(actionItem.slug),
  }))
  console.log({ actionItemsWithCurrentENVSlugs });

  return (
    <StylesProvider injectFirst>
      <Stack
        className="checklist-preview-container container px0 mb20 mt10"
        horizontalAlign="center"
      >
        <CheckList
          actionItemsData={actionItemsWithCurrentENVSlugs}
          completeAny={checklist.completeAny}
          completionRule={checklist.completionRules}
          label={checklist.label}
          heading={checklist.header}
          order={checklist.actionOrder}
          subHeading={checklist.subheader}
          completionMessage={checklist.completionMessage}
          checklistOrder={checklist.actionOrder}
          isChecklistLocked={false}
          goToSignUp={goToSignUp}
        />
      </Stack>
    </StylesProvider>
  );
};

export default ChecklistPreviewPage;
